import React, { useEffect, useRef, useState } from 'react';
import { authApi } from '../api';

// Google's own "Continue with Google" button (Google Identity Services). It appears only when the
// backend has GOOGLE_CLIENT_ID set, followed by an "or" line above the email form.
let clientIdPromise;
const googleClientId = () => {
  if (!clientIdPromise) clientIdPromise = authApi.providers().then(p => p.google_client_id).catch(() => null);
  return clientIdPromise;
};

let scriptPromise;
const loadGoogle = () => {
  if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("Couldn't load Google sign-in"));
    };
    document.head.appendChild(script);
  });
  return scriptPromise;
};

// text: 'continue_with' (sign in) or 'signup_with'. onCredential gets Google's ID token.
export function GoogleButton({ onCredential, text = 'continue_with' }) {
  const slot = useRef(null);
  const onCredentialRef = useRef(onCredential);
  onCredentialRef.current = onCredential;
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const clientId = await googleClientId();
      if (!clientId || cancelled) return;
      const google = await loadGoogle().catch(() => null);
      if (!google || cancelled || !slot.current) return;
      google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => onCredentialRef.current(response.credential),
        ux_mode: 'popup',
        context: text === 'signup_with' ? 'signup' : 'signin',
      });
      google.accounts.id.renderButton(slot.current, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        shape: 'rectangular',
        text,
        logo_alignment: 'center',
        locale: 'en',
        width: Math.min(400, slot.current.offsetWidth || 360),
      });
      setReady(true);
    })();
    return () => { cancelled = true; };
  }, [text]);

  return (
    <div className="google-signin">
      <div ref={slot} className="google-signin-button" />
      {ready && <div className="google-signin-or"><span>or</span></div>}
    </div>
  );
}
